import { render } from "./Headless.vue?vue&type=template&id=2e41d7a2"
import script from "./Headless.vue?vue&type=script&lang=js"
export * from "./Headless.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__